export default {
  filterOoo: 'Filtrovat...',
  equals: 'Rovno',
  inRange: 'V rozmezí',
  inRangeStart: 'od',
  inRangeEnd: 'do',
  lessThan: 'Menší než',
  lessThanOrEqual: 'Menší než nebo rovno',
  greaterThan: 'Větší než',
  greaterThanOrEqual: 'Větší než nebo rovno',
  contains: 'Obsahuje',
  andCondition: 'A',
  orCondition: 'NEBO',
  noRowsToShow: 'Žádné řádky k zobrazení',
};
